import moment from 'moment';
import { EnvironmentService } from '@algomusinc/services';
export const getDefaultCalendarIds = (timeframeList: Array<any>) => {
  const environment = EnvironmentService.environment;
  let startMonthDate = moment().add(-1, 'M');
  let endMonthDate = moment().add(environment.DEFAULT_SELECTED_MONTH - 2, 'M');
  let allDates = enumerateDaysBetweenDates(
    startMonthDate.clone(),
    endMonthDate.clone()
  );
  let filteredTimeframeByMonth = timeframeList.filter((row) =>
    allDates.find(
      (el: Date) => el.getMonth() === new Date(row.weekStartDate).getMonth()
    )
  );
  let filteredTimeframeByStartYear = filteredTimeframeByMonth.filter(
    (el) =>
      new Date(el.weekStartDate).getMonth() >= startMonthDate.month() &&
      new Date(el.weekStartDate).getFullYear() == startMonthDate.year()
  );
  let filteredTimeframeByEndYear = filteredTimeframeByMonth.filter(
    (el) =>
      new Date(el.weekStartDate).getMonth() <= endMonthDate.month() &&
      new Date(el.weekStartDate).getFullYear() == endMonthDate.year()
  );
  return [...filteredTimeframeByStartYear, ...filteredTimeframeByEndYear];
  const currentWeek = moment().weekday(6);
  const currentCalendar = timeframeList.find(
    (row) =>
      moment(row.weekStartDate).format('YYYY-MM-DD') ===
      currentWeek.format('YYYY-MM-DD')
  );
  const calendarIds = [];
  for (let i = 0; i <= 4; i++) {
    calendarIds.push(currentCalendar.calendarId - i);
  }
  for (let i = 1; i <= 11; i++) {
    calendarIds.push(currentCalendar.calendarId + i);
  }
  return calendarIds;
};
var enumerateDaysBetweenDates = (startDate: any, endDate: any) => {
  var dates = [];

  var currDate = startDate.startOf('day');
  var lastDate = endDate.startOf('day');

  while (currDate.add(1, 'days').diff(lastDate) < 0) {
    dates.push(currDate.clone().toDate());
  }

  return dates;
};
